import React, { useState } from 'react';
import DustAnimation from './DustAnimation';
import { RefreshCw } from 'lucide-react';

interface BalanceCardProps {
  title: string;
  value: React.ReactNode;
  className?: string;
  showDust?: boolean;
  onRefreshClick?: () => void;
  refreshing?: boolean;
  dustColorSet?: string[];
}

const BalanceCard: React.FC<BalanceCardProps> = ({ 
  title, 
  value, 
  className = '',
  showDust = true,
  onRefreshClick,
  refreshing = false,
  dustColorSet
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Цвет эффекта при наведении
  let hoverBg = 'from-green-400/10 to-transparent';
  if (dustColorSet && dustColorSet[0]) {
    if (dustColorSet[0].includes('yellow')) hoverBg = 'from-yellow-400/10 to-transparent';
    else if (dustColorSet[0].includes('gray')) hoverBg = 'from-gray-300/10 to-transparent';
    else if (dustColorSet[0].includes('orange')) hoverBg = 'from-orange-400/10 to-transparent';
  }

  return (
    <div 
      className={`bg-[#23262F] rounded-xl shadow p-6 flex flex-col items-start relative overflow-hidden transition-all duration-300 hover:shadow-lg hover:scale-[1.02] ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Анимация пыли */}
      {showDust && <DustAnimation colorSet={dustColorSet} />}
      
      {/* Контент карточки */}
      <div className="relative z-10 w-full flex items-center justify-between">
        <div>
          <span className="text-sm text-[#B1B5C3] mb-2 block">{title}</span>
          <span className="text-3xl font-bold text-green-400 block transition-all duration-300">
            {value}
          </span>
        </div>
        {onRefreshClick && (
          <button
            onClick={onRefreshClick}
            type="button"
            className="ml-4 p-2 rounded-full hover:bg-[#353945] transition-colors text-gray-400 hover:text-white focus:outline-none"
            title="Обновить баланс"
            disabled={refreshing}
            style={{ minWidth: 40, minHeight: 40 }}
          >
            <RefreshCw className={refreshing ? 'animate-spin' : ''} size={24} />
          </button>
        )}
      </div>
      
      {/* Дополнительный эффект при наведении */}
      {isHovered && (
        dustColorSet && dustColorSet[0] ? (
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `linear-gradient(135deg, ${dustColorSet[0]}22 0%, transparent 100%)`
            }}
          />
        ) : (
          <div className={`absolute inset-0 bg-gradient-to-br ${hoverBg} pointer-events-none`} />
        )
      )}
    </div>
  );
};

export default BalanceCard; 